module.exports = __webpack_public_path__ + "img/login_tab01_01.80ad6534.png";